module.exports = __webpack_public_path__ + "img/gift-box.d1925b87.svg";